export const chiliPiperIframeSandbox =
  "allow-scripts allow-same-origin allow-forms allow-popups allow-popups-to-escape-sandbox allow-downloads";

export type ChiliPiperLead = {
  FirstName: string;
  Email: string;
  LastName?: string;
  Company?: string;
};

// Parent -> shell.
export type ChiliPiperOpenMessage = {
  type: "3b-chili-piper-open";
  lead: ChiliPiperLead;
};

// Shell -> parent, translated from ChiliPiper's own lifecycle events.
export type ChiliPiperShellMessage =
  | { type: "3b-chili-piper-ready" }
  | { type: "3b-chili-piper-availability"; hasAvailability: boolean }
  | { type: "3b-chili-piper-booked" }
  | { type: "3b-chili-piper-closed" }
  | { type: "3b-chili-piper-error" };
